// Copyright (c) 2024 by Audere

import { Params, RouterProvider, createBrowserRouter } from "react-router-dom";

import { CssBaseline } from "@mui/material";
import Dashboard from "./app/screens/Dashboard";
import LabelTypeSelect from "./app/screens/LabelTypeSelect";
import Login from "./app/screens/Login";
import React from "react";
import RequireAuth from "./app/components/RequireAuth";
import { Link } from "./app/components/Breadcrumbs";
import Error from "./app/components/Error";

const router = createBrowserRouter([
  {
    children: [
      {
        path: "/",
        element: <Login />,
        errorElement: <Error />,
      },
      {
        element: <RequireAuth />,
        children: [
          {
            path: "label-type-select",
            element: <LabelTypeSelect />,
          },
          {
            path: "/dashboard/:labelTypeID",
            element: <Dashboard />,
            handle: {
              crumb: () => (
                <Link href="/label-type-select">Labeling Type Selection</Link>
              ),
            },
            children: [
              {
                path: "conversation/:conversationUID",
                element: <Dashboard />,
                handle: {
                  crumb: (params: Params) => (
                    <Link href={`/dashboard/${params.labelTypeID}`}>
                      Conversations
                    </Link>
                  ),
                },
                children: [
                  {
                    path: ":taskID",
                    element: <Dashboard />,
                    handle: {
                      crumb: (params: Params) => (
                        <Link
                          href={
                            `/dashboard/${params.labelTypeId}
                            /conversation/${params.conversation_uid}`
                          }
                        >
                          {params.conversationUID}
                        </Link>
                      ),
                    },
                    children: [
                      {
                        path: "edit",
                        element: <Dashboard />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);

const App: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <RouterProvider router={router} />
    </>
  );
};
export default App;
